import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { useScreenShare } from "@100mslive/react-sdk";
import { ScreenShareHintModal } from "../ScreenshareHintModal";
import { WidgetCard } from "./WidgetCard";
import { useWidgetToggle } from "../AppData/useSidepane";
import { useShowAudioShare } from "../AppData/useUISettings";

export const ScreenshareAudio = () => {
  const {
    amIScreenSharing,
    screenShareVideoTrackId: video,
    screenShareAudioTrackId: audio,
    toggleScreenShare,
  } = useScreenShare();
  const isAudioScreenshare = amIScreenSharing && !video && !!audio;
  const [showModal, setShowModal] = useState(false);
  const { showAudioShare } = useShowAudioShare();
  const toggleWidget = useWidgetToggle();
  const { t } = useTranslation();

  if (!showAudioShare) {
    return null;
  }
  return (
    <Fragment>
      <WidgetCard
        title={
          !isAudioScreenshare
            ? t("btn_share_music", "Share music")
            : t("btn_stop_sharing_music", "Stop sharing music")
        }
        subtitle={
          !isAudioScreenshare
            ? t(
                "msg_play_music_from",
                "Play music from Spotify or any other tab"
              )
            : t(
                "msg_stop_playing_music",
                "Stop playing music from Spotify or any other tab"
              )
        }
        imageSrc={require("../../images/audio.png")}
        onClick={() => {
          if (amIScreenSharing) {
            toggleScreenShare();
          } else {
            setShowModal(true);
          }
        }}
      />
      {showModal && (
        <ScreenShareHintModal
          onClose={() => {
            setShowModal(false);
            toggleWidget();
          }}
        />
      )}
    </Fragment>
  );
};
